module.exports = __webpack_public_path__ + "fonts/display-ultralight.5164ce97.woff2";